import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ColetorRoutingModule } from './coletor-routing.module';
import { ColetorComponent } from './coletor.component';
import { MaterialModule } from 'src/app/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { RouterModule } from '@angular/router';
import { InputMaskModule } from 'racoon-mask-raw';
import { TecidosCaptadosModule } from '../tecidos-captados/tecidos-captados.module';
import { TecidosModule } from '../tecidos-captados/tecidos/tecidos.module';


@NgModule({
  declarations: [ColetorComponent],
  imports: [
    CommonModule,
    ColetorRoutingModule,
    MaterialModule,
    FormsModule,
    NgxMaskModule,
    RouterModule,
    ReactiveFormsModule,
    InputMaskModule,
    TecidosCaptadosModule,
    TecidosModule,
  ],
  exports:[ColetorComponent]
})
export class ColetorModule { }
